import { render, staticRenderFns } from "./SettingsBotThemeLauncherIcon.vue?vue&type=template&id=6d314fa0&"
import script from "./SettingsBotThemeLauncherIcon.vue?vue&type=script&lang=js&"
export * from "./SettingsBotThemeLauncherIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports